<template>
<div class="contact-form-component" id="contact" :class="{'loading' : loading}">
	<h4>Contactez Nous</h4>
	<input type="text" name="onfirstname" v-model="honeyPot" placeholder="Ne pas remplir" aria-hidden="true" class="hidden">
	<div class="two-col">
		<input type="text" name="name" v-model="name" placeholder="Nom" :class="{'has-error' : hasError('name')}">
		<input type="text" name="name" v-model="objet" placeholder="Objet" :class="{'has-error' : hasError('objet')}">
	</div>
	<div class="two-col">
		<input type="email" name="email" v-model="email" placeholder="Adresse e-mail" :class="{'has-error' : hasError('email')}">
		<input type="tel" name="phone"  v-model="phone" placeholder="Téléphone" :class="{'has-error' : hasError('phone')}" pattern="^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$" >
	</div>
	<textarea placeholder="Votre message" v-model="message" :class="{'has-error' : hasError('message')}"></textarea>
	<div class="text-center">
		<button class="btn btn-primary btn-blue" @click.prevent="send">Envoyer</button>
	</div>
	<div v-show="loading" class="loader centered"></div>
</div>
</template>
<script>
export default{


	data(){
		return {
			loading: false,

			honeyPot: '',
			name: '',
			objet: '',
			email: '',
			phone: '',
			message: '',

			errors: [

			]
		}
	},

	beforeMount(){
		// console.log('beforeMount')
	},

	methods: {

		hasError(key){
			return this.errors[key] !== undefined
		},


		send(){
			console.log('SEND')
			if (this.loading) {
				return false;
			}


			if (this.honeyPot.length > 0) {
				return false;
			}

			this.loading = true
			this.errors = [];
			console.log(this.objet);
			axios({
				url: base.url + '?action=contact',
				method: 'POST',
				dataType: 'json',
				data: {
					nonce: base.nonce,
					name: this.name,
					email: this.email,
					phone: this.phone,
					message: this.message,
					honeyPot: this.honeyPot,
					objet: this.objet,
				},
				contentType: 'application/json'

			})
			.then(res => {
				console.log(res)

				if (res.data.status === 'error') {
					this.errors = res.data.errors
					console.log(typeof res.data.errors)
					_.forEach(res.data.errors, (err, key) => {
						console.log(key + ':' + err)
						iziToast.error({
							title: 'Erreur !',
							message: err,
							timeout: 2500,
							progressBar: true
						})
					})

					this.$forceUpdate()
					this.loading = false
				}else if(res.data.status === 'success'){

					iziToast.success({
						title: 'Succès',
						message: 'Message envoyé, merci !',
						position: 'topRight'
					});

					this.name = ''
					this.email = ''
					this.phone = ''
					this.message = ''
					this.objet = ''

					this.loading = false
				}else{

					iziToast.error({
						title: 'Erreur !',
						message: 'Un problème est survenu !'
					})

					this.loading = false

				}
			})
			.catch(err => {
				console.log(err)
					this.loading = false
			})
		}

	}


}
</script>